// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import { get } from 'lodash'
import caculateWidthBy10FontSize from '../caculateFontSize.js'
import { getMaxValue, getMaxLengthValue } from '../utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'
const { height, heightHor } = getEchartHeightAndBottomByLocale('usersAndConversion')
export default function transformer(
  data = {},
  dateToWeek = {},
  key = 'usersAndConversion',
  direction,
) {
  const chartHeight = direction === 'vertical' ? height : heightHor
  const { name, period, indicators } = data
  return {
    title: name,
    period,
    indicators,
    chartData: [parseChartsData(data.chartData, dateToWeek, chartHeight)],
    funnelData: get(data, 'funnelData.conversion', []),
    chartkey: key,
    chartHeight,
  }
}
function parseChartsData(chartData = {}, dateToWeek, chartHeight) {
  const { p1 = [], p2 = [], p1p2 = [] } = chartData || {}
  const max = getMaxValue()
  const maxConnectivity = getMaxLengthValue()
  const xAxisData = p1p2.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 16
  const right =
    (maxConnectivity
      ? caculateWidthBy10FontSize(maxConnectivity + '%')
      : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    grid: {
      top: 26,
      left,
      right,
      bottom: 56,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      {
        name: vueI18n.t('FoodB_20250414_uqsI_JhAj' /** P1 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
      {
        name: vueI18n.t('FoodB_20250414_cwcj_LKFT' /** P2 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
      {
        name: vueI18n.t('FoodB_20250414_hanC_RXkJ' /** P1*P2 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
    ]),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        name: 'P1/P2/P1*P2',
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_20250414_uqsI_JhAj' /** P1 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#41CD16',
        lineStyle: {
          width: 1.5,
        },
        data: p1.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_20250414_cwcj_LKFT' /** P2 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#FF9A34',
        lineStyle: {
          width: 1.5,
        },
        data: p2.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_20250414_hanC_RXkJ' /** P1*P2 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#4A9DFC',
        lineStyle: {
          width: 1.5,
        },
        data: p1p2.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}
